import { List } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { externalQuoteTheme } from 'external-quote/styles';

interface IProps extends ICellRendererParams {
  onClick: (partBomId: number) => void;
}

export const BomButtonCell = ({ data, onClick }: IProps) => {
  if (!data?.partBomId) {
    return null;
  }

  const handleClick = () => {
    onClick(data.partBomId);
  };

  return (
    <button
      onClick={handleClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        border: 'none',
        backgroundColor: externalQuoteTheme.colors.primaryBlue,
        borderRadius: '3px',
        fontSize: '12px',
        color: '#FFFFFF',
        cursor: 'pointer',
        height: '24px',
        whiteSpace: 'nowrap',
      }}
    >
      <List size={12} />
      BOM
    </button>
  );
};
